"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var castArray_1 = __importDefault(require("lodash/castArray"));
var toString_1 = __importDefault(require("lodash/toString"));
var react_1 = __importDefault(require("react"));
var Button_1 = __importStar(require("../../../Button"));
var Icon_1 = __importStar(require("../../../Icon"));
var Input_1 = __importDefault(require("../../../Input"));
var index_1 = __importDefault(require("../index"));
var ValuesFilterItem = /** @class */ (function (_super) {
    __extends(ValuesFilterItem, _super);
    function ValuesFilterItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectedNames = function () {
            var selected = _this.props.selected;
            var selectedNames = [];
            _this.values.forEach(function (item) {
                var key = toString_1.default(item.id);
                var choosen = castArray_1.default(selected).indexOf(key) >= 0;
                if (choosen) {
                    selectedNames.push(item.name);
                }
            });
            return selectedNames;
        };
        _this.renderSelect = function () {
            return null;
        };
        _this.renderRows = function () {
            return [];
        };
        _this.renderLabel = function () {
            var localization = _this.props.localization;
            var label = _this.props.label || _this.props.id;
            var selectedNames = _this.selectedNames();
            var text;
            if (selectedNames.length === Object.keys(_this.values).length) {
                text = localization.all;
            }
            else if (selectedNames.length === 0) {
                text = localization.empty;
            }
            else {
                text = selectedNames.join(", ");
            }
            return (react_1.default.createElement("div", null,
                react_1.default.createElement("label", null, label),
                react_1.default.createElement("div", { className: "fake_input fake_input--withIcon", onClick: _this.openDialog },
                    text,
                    react_1.default.createElement(Icon_1.default, { icon: Icon_1.IconType.ArrowBottom, width: 24, height: 24 }))));
        };
        _this.renderDropdownBody = function () {
            var localization = _this.props.localization;
            var rows = _this.renderRows();
            var select = _this.renderSelect();
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "header" },
                    react_1.default.createElement(Input_1.default, { placeholder: localization.search, onChange: _this.selectFilter, value: _this.state.filter })),
                react_1.default.createElement("div", { className: "inputs" },
                    select,
                    rows),
                react_1.default.createElement("div", { className: "buttons" },
                    react_1.default.createElement(Button_1.default, { variant: Button_1.ButtonVariant.Active, onClick: _this.changeFilters }, localization.confirm))));
        };
        return _this;
    }
    Object.defineProperty(ValuesFilterItem.prototype, "values", {
        get: function () {
            return this.props.values || [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ValuesFilterItem.prototype, "filteredValues", {
        get: function () {
            var filter = this.state.filter;
            if (this.props.values) {
                return this.props.values.filter(function (item) { return item.name.toLocaleLowerCase().indexOf(filter.toLocaleLowerCase()) >= 0; });
            }
            return [];
        },
        enumerable: false,
        configurable: true
    });
    return ValuesFilterItem;
}(index_1.default));
exports.default = ValuesFilterItem;
//# sourceMappingURL=index.js.map